import * as React from 'react';
import { useParams } from 'react-router';
import { IImpersonationContext } from '../../../extViewmodels';
import {
	AdminDrawerToolbar,
	AppDrawerToolbarButton,
	SideDrawer,
	StickyAppDrawerContent,
} from '../../../web/components-v2/Drawer/AppDrawer';
import { SparklesIcon } from '../../../web/components/svgs/icons/SparklesIcon';
import { ContentCalendarAssistantChat } from '../../../web/containers/templates/AssistantChat/ContentCalendarAssistantChat';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountContentCalendar } from '../../containers/account/AccountContentCalendar';

export const AdminAccountContentCalendarPage: React.FC = () => {
	const params = useParams<{ id: string }>();
	const impersonationContext: IImpersonationContext = { account: { id: params.id } };

	return (
		<AdminDashboardPageLayout
			sidebarChildren={
				<SideDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<ContentCalendarAssistantChat impersonationContext={impersonationContext} />
					</StickyAppDrawerContent>

					<AdminDrawerToolbar>
						<AppDrawerToolbarButton value='ai-assistant' tooltip='AI Assistant'>
							<SparklesIcon />
						</AppDrawerToolbarButton>
					</AdminDrawerToolbar>
				</SideDrawer>
			}
		>
			<AccountContentCalendar />
		</AdminDashboardPageLayout>
	);
};
